import { render, staticRenderFns } from "./AddAmountToGiftCard.vue?vue&type=template&id=3069c4bd&scoped=true"
import script from "./AddAmountToGiftCard.vue?vue&type=script&lang=js"
export * from "./AddAmountToGiftCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3069c4bd",
  null
  
)

export default component.exports